module.exports = __webpack_public_path__ + "static/media/my.3e0c9683.svg";